import React, { useState } from 'react';
import ConfirmModal from '../../common/ConfirmModal';
import LoadingComponent from '../../common/LoadingComponent';
import * as mh from 'helpers/medicationHelpers';
import * as gh from 'helpers/generalHelpers';
import { getMedsHistory, getMedsHistoryLoaded, deleteMedsHistory, getCurrentUserId  } from 'store/storeValtio';
import { deleteHistoryInDb } from 'store/localDb';

export default function MedicationHistoryList({medId}) {
  const [popup, setPopup] = useState({
    show: false,
    confirm: 'Delete',
    medName: 'tempName',
    taken: null,
    id: null,
  });

  const currentUserId = getCurrentUserId();
  var medsHistory = getMedsHistory();
  console.log('MedicationHistoryList', medId);
  const medsHistoryLoaded = getMedsHistoryLoaded();
  if (!medsHistoryLoaded) return (<LoadingComponent/>);

  // if history for just one med, filter it out
  var hist = null;
  if ( medId ) {
    hist = medsHistory.filter(h => h.medicationId === medId);
  } else {
    hist = medsHistory;
  }


  // This will show the Cofirmation Box

  const handleDelete = (mn, td, h) => {
    console.log('handleDelete', mn, td, h);
    setPopup({ 
      show: true, 
      confirm: 'Delete',
      medName: mn, 
      taken: td, 
      id: h.historyId 
    });
    //setIsOpen(true);
  };

  // This will perform the deletion and hide the Confirmation Box

  const handleDeleteTrue = () => {
    console.log('handleDeleteTrue', popup);
    handleDeleteHist(popup.id);
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"

  const handleDeleteFalse = () => {
    console.log('handleDeleteFalse');
    setPopup({ show: false, taken: null, id: null });
  };

  async function handleDeleteHist(hid) {
    console.log('handleDeleteHist', hid);
    await deleteHistoryInDb(currentUserId, hid);
    medsHistory = deleteMedsHistory(hid);
    setPopup({ show: false, taken: null, id: null });
  }

  if (hist.length === 0) {
    var msg = "???";
    if (!medId) {
      msg = 'There is no medication history';
    } else {
      msg = 'There is no history for this medication';
    }
    return(
      <div className='w-full flex flex-col justify-center font-semibold text-xl text-center my-8'>
          {msg}
      </div>
  )}

  return (
    <div>
      <ConfirmModal 
        open={popup.show} 
        confirmButton={popup.confirm}
        onConfirm={()=>handleDeleteTrue()}
        onCancel={()=>handleDeleteFalse()}
        title={popup.medName}
        content={popup.taken}
        />

      {hist.map((h, ix) => {
        //console.log("hist list map:", h);
        //console.log("hist list date:", h.date);
        // if for single med, skip the others

        const med = mh.lookupMed(h.medicationId);
        if (!med) {
          // should never happen
          console.log("Med NOT FOUND: ", h.medicationId);
          return(<div>Med Not Found: {h.medicationId} (h.historyId)</div>);
        }
        //console.log('lookupMed',med, h.medicationId);
        //const t = moment(h.date).format('hh:mm A');
        const t = gh.formatTime(h.date);
        const ltAgo = mh.formatTaken(h);
        const td = `${h.quantity} Taken ${ltAgo} at ${t}`;

        return (
          <div className='mcard border-2 border-gray-200 mb-1' key={ix}>
            {typeof medId === 'undefined' &&
            <div className='mcard-header'>{med.name}</div>
            }
            <div className='histItem'>
              <div>
                {ltAgo}
                <br />
                {t}
              </div>
              <button
                onClick={() => handleDelete(med.name, td, h)}
                className='histItemBtn bg-red-700'
              >
                Delete
              </button>
            </div>
          </div>
        );
      })}
      {/* <div style={{ height: '80px' }} /> */}
    </div>
  );
}